export var CAR = 'CAR';
export var CRUISE = 'CRUISE';
export var FLIGHT = 'FLIGHT';
export var HOTEL = 'HOTEL';
export var PACKAGE = 'PACKAGE';
export var PRODUCT_ICONS = [CAR, CRUISE, FLIGHT, HOTEL, PACKAGE];
//# sourceMappingURL=productIcons.js.map